




















































































































































import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import {cloneDeep, isEqual} from "lodash";
import {InputWings, SelectWings} from "wings-ui-components";
import { PreprocessingRuleItem, PreprocessingRuleItemImpl } from '@/store/settings/preprocessing_rules/types';
import { notifyConfirm, notifyDelete, notifyError } from '@/utils/notify-helper';
import { TransportItem } from '@/store/transport/types';
import { ActionLog } from '@/store/auth/types';
import {getTranslatedParams} from "@/utils/notify-utils";

Component.registerHooks(['beforeRouteLeave']);

@Component({components: { SelectWings, InputWings }})
export default class PreprocessingRule extends Vue {
  @Ref('validator') private validator: any;

  @Getter('transports') transportsList!: TransportItem[];
  @Getter("positionList") positionList: any;

  @Action('getTransports') actionGetTransports: any;
  @Action('getPartners') actionGetPartners: any;
  @Action('getAccounts') actionGetAccounts: any;
  @Action('getTemplates') actionGetTemplates: any;
  @Action('getOriginators') actionGetOriginators: any;

  @Action('savePreprocessingRuleItem') actionSave: any;
  @Action('deletePreprocessingRuleItem') actionDelete: any;
  @Action('getPreprocessingRuleItem') actionGetItem: any;
  @Action("actionLog") actionLog: any;

  private item: PreprocessingRuleItem = new PreprocessingRuleItemImpl();
  private itemSaved: PreprocessingRuleItem = new PreprocessingRuleItemImpl();
  private logObject: ActionLog = {};

  partnersList: any = []
  accountsList: any = []
  templatesList: any = []
  originatorsList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({transport: this.selectedTransport?.name, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({transport: this.selectedTransport?.name, partner_id: this.item.partner_id, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async getTemplatesList(filter: any) {
    const items = await this.actionGetTemplates({transport: this.selectedTransport?.name, filter: {partner_id: this.item.partner_id, ...filter}});
    this.templatesList = (filter?.page_number > 1) ? this.templatesList.concat(items) : items
  }

  async getOriginatorsList(filter: any) {
    const items = await this.actionGetOriginators({transport: this.selectedTransport?.name, partner_id: this.item.partner_id, ...filter});
    this.originatorsList = (filter?.page_number > 1) ? this.originatorsList.concat(items) : items
  }

  async created() {
    try {
      await this.actionGetTransports();
      if (this.$route.params.id) {
        try {
          this.logObject = {
            action_page: this.$route.meta.msgKey,
            action: "Viewing",
            action_status: "success",
            object_type: "Additional processing rule",
            addititional_info: {ID: this.$route.params.id}
          }
          const data = await this.actionGetItem(this.$route.params.id);
          await this.actionLog(this.logObject);
          this.item = Object.assign({}, this.item, data);
          this.itemSaved = cloneDeep(this.item);
        } catch (error) {

        }

        if (this.item.partner_id) this.partnersList = await this.actionGetPartners({id: this.item.partner_id});
        if (this.item.account_id) this.accountsList = await this.actionGetAccounts({id: this.item.account_id});
        if (this.item.template_id) this.templatesList = await this.actionGetTemplates({transport: this.selectedTransport?.name, filter: {id: this.item.template_id}});
        if (this.item.originator_id) this.originatorsList = await this.actionGetOriginators({id: this.item.originator_id});
      }
    } catch (error) {
      this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(error);
    }
  }

  get selectedTransport(): TransportItem|undefined {
    return this.transportsList.find((t: TransportItem) =>
      t.id === this.item.channel_id);
  }

  get transportNeededMessage() { return !this.item.channel_id ? 'Выберите транспорт' : ''; }

  get partnerNeededMessage() { return !this.item.partner_id ? 'Выберите клиента' : ''; }

  @Watch('item.channel_id', {immediate: true, deep: true})
  private onTransportChange(newVal: any, oldVal: any) {
    if (oldVal) {
      this.item.partner_id = undefined;
      this.item.account_id = undefined;
      this.item.template_id = undefined;
      this.item.originator_id = undefined;
    }
  }

  @Watch('item.partner_id', { immediate: true, deep: true })
  private onPartnerChange(newVal: any, oldVal: any) {
    if (oldVal) {
      this.item.account_id = undefined;
      this.item.template_id = undefined;
      this.item.originator_id = undefined;
    }
  }

  back() {
    this.$router.push('/settings/additional_rules/');
  }

  onSaveItem(): Promise<any> {
    return new Promise( async () => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        return
      }
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          action_status: "success",
          object_type: "Additional processing rule",
          addititional_info: getTranslatedParams(this.item)
        }
        await this.actionSave(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    });
  }

  onDeleteItem(): Promise<any> {
    return new Promise( async () => {
      if (!await notifyDelete()) {
        return
      }
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Removal",
          action_status: "success",
          object_type: "Additional processing rule",
          addititional_info: {ID: this.item.id}
        }
        await this.actionDelete(this.item);
        await this.actionLog(this.logObject);
        this.itemSaved = this.item;
        this.back();
      } catch (error) {
        this.actionLog({...this.logObject, action_status: "failed"});
        notifyError(error);
      }
    });
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    let isChange = !isEqual(this.item, this.itemSaved);
    notifyConfirm(isChange, this.onSaveItem, next);
  }
};
